import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './auth-context';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, initializing } = useAuth();
  const location = useLocation();

  if (initializing) {
    return (
      <main className="centered-page">
        <p role="status">Checking your session…</p>
      </main>
    );
  }
  if (!session) {
    // Remember the requested page so sign-in can return the visitor to it.
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/signin" replace state={{ from }} />;
  }
  return children;
}
